import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { compose } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";
import ReactPaginate from "react-paginate";
import moment from "moment";
import uuid from "uuid/v4";

import { setA11yContent } from "../NavigationHelper/actions";
import { media, isMobile } from "utils/style";
import { checkAMLob } from "utils/checkAMLob";
import { checkNestedObject } from "utils/checkNestedObject";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { renderDate } from "utils/renderDate";
import { agentSelectCustomer } from "./actions";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";

import { paginationArrow as PaginationArrow } from "../../../../assets/svgs/paginationArrow";
import { Tile as CommonTile } from "common-components/Tile";

import { AuthorizedAgentNoCustomers } from "./AuthorizedAgentNoCustomers";
import FetchPageContent from "../../../hoc/FetchPageContent";
import { Table, TableHead, TableHeader, TableBody, TableRow, Cell } from "@vds/tables";
import { TitleLockup } from "@vds/type-lockups";
import { TextLink } from "@vds/buttons";
import { Tilelet } from "@vds/tiles";
import { Pagination } from "@vds/pagination";

class AuthorizedAgentLanding extends Component {
  state = {
    customerDisplayList: [],
    fullCustomerList: [],
    selectedPage: 1,
    hasCustomers: false,
    statusText: {}
  };

  componentDidMount() {
    if (checkNestedObject(window.reactGlobals, "agentInfo", "agentAssociationList")) {
      const { agentAssociationList } = window.reactGlobals.agentInfo;

      const setBreadCrumbs = () => {
        if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
          const { landingPage } = this.props.breadCrumbs;

          this.props.setBreadcrumbList([{ label: landingPage, path: "/privacy/secure/authorized-agent" }]);
        }
      };

      if (agentAssociationList && agentAssociationList.length) {
        setBreadCrumbs();

        const customerList = agentAssociationList.map(customer => ({
          ...customer,
          uniqueCustId: uuid()
        }));

        const statusText = checkNestedObject(this.props.statusText, "statusText", [0], "approved");

        this.setState({
          customerDisplayList: customerList.slice(0, 5),
          fullCustomerList: customerList,
          hasCustomers: true,
          statusText: statusText ? { ...this.props.statusText.statusText[0] } : {}
        });
      } else {
        setBreadCrumbs();
      }
    }

    if (checkNestedObject(this.props, "sc_pagetitle")) {
      this.props.setA11yContent("authorized agent landing page", this.props.sc_pagetitle);
    }
  }

  componentWillUnmount() {
    this.props.setBreadcrumbList([]);
  }

  handlePageClick = data => {
    const selected = data;
    const offset = Math.ceil(selected * 5);

    const { fullCustomerList } = this.state;
    this.setState({
      customerDisplayList: fullCustomerList.slice(offset-5, offset),
      selectedPage: selected
    });
  };

  handleCustomerSelect = customer => {
    this.props.agentSelectCustomer(customer);
    this.props.history.push("authorized-agent/customer");
  };

  renderStatusColumn = str => {
    const { statusText } = this.state;

    switch (str) {
      case null:
        return "";
      case "APPROVED":
        return statusText.approved;
      case "NOT APPROVED":
        return statusText.notApproved;
      case "PENDING_APPROVAL":
        return statusText.pendingApproval;
      case "EXPIRED":
        return statusText.expired;
      default:
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
  };

  renderCustomerIdentifier = customerInfo => {
    if (
      customerInfo.serviceType &&
      typeof customerInfo.serviceType === "string" &&
      customerInfo.serviceType.toLowerCase() === "vzw"
    ) {
      return formatPhoneNumber(customerInfo.mtn);
    }
    if (customerInfo.accountId) {
      return customerInfo.accountId;
    }
    return "-";
  };

  render() {
    if (checkAMLob() !== "agent") {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    const { agentExpiryDate } = window.reactGlobals.agentInfo;
    const expireDate = agentExpiryDate
      ? moment(new Date(agentExpiryDate)).format("MMM DD, YYYY")
      : moment()
        .add(6, "M")
        .format("MMM DD, YYYY");

    if (!this.state.hasCustomers) {
      return (
        <AuthorizedAgentNoCustomers
          pageContent={this.props.agent_landing_page_no_customers}
          agentExpiryDate={expireDate}
        />
      );
    }

    const [
      topOfPage,
      customerDisplayList,
      {
        tileContent: [tileContent]
      }
    ] = this.props.pageContent;

    return (
      <Container style={{ marginTop: "0", paddingTop: "0" }}>
        <SubContainer>
          <TitleLockup
            surface='light'
            textAlignment='left'
            data={{
              title: {
                size: 'titleXLarge',
                bold: false,
                children: <H1>{convertStringToElements(topOfPage.section_title)}</H1>
              },
              subtitle: {
                size: 'bodyLarge',
                primitive: 'p',
                children:
                  <>
                    <HeaderDesc>{convertStringToElements(topOfPage.section_description)}</HeaderDesc>
                    <div>
                      <H2>{convertStringToElements(customerDisplayList.section_title)}</H2>
                      <P>{convertStringToElements(customerDisplayList.section_description)}</P>
                    </div>
                  </>
              }
            }}
          />

          <TableContainer>
            <Table
              striped={false}
              bottomLine="primary"
              surface="light"
              padding="standard"
            >
              <TableHead bottomLine="primary">
                {customerDisplayList.genericList[0].list.map(item => (
                  <Tableheader key={item.jsonKey}> {item.jsonValue} </Tableheader>
                ))}
              </TableHead>
              <TableBody>
                {this.state.customerDisplayList.map(item => (
                  <>
                    <TableRow>
                      <Cell >
                        <TextLink
                          data-qm-encrypt="true"
                          type="standAlone"
                          onClick={() => this.handleCustomerSelect(item)}
                        >
                          {item.accountName}
                        </TextLink>
                      </Cell>
                      <Cell data-qm-encrypt="true">{this.renderCustomerIdentifier(item)}</Cell>
                      <Cell>{renderDate(item.endDate)}</Cell>
                      <Cell>{this.renderStatusColumn(item.status)}</Cell>
                      <Cell>{item.agentEmailId}</Cell>
                    </TableRow>
                  </>
                ))
                }
              </TableBody>
            </Table>
          </TableContainer>
          
          {this.state.fullCustomerList.length > 5 && (
           <PaginationDiv>
            <Pagination
              selectedPage={this.state.selectedPage}
              selectPage={this.handlePageClick}
              total={Math.ceil(this.state.fullCustomerList.length / 5)}
              surface="light"
              showArrow={true} 
            />   
            </PaginationDiv>
          )}

          <div style={{ marginTop: "48px" }}>
            <H3>
              {convertStringToElements(tileContent.title)}
            </H3>

            <div style={{ display: "flex", gap: "24px", flexWrap: "wrap", marginTop: "30px" }}>
              {tileContent.list.map(tile => (
                <Tilelet
                  viewport={isMobile ? "mobile" : "desktop"}
                  href={tile.tileLink}
                  title={{
                    bold: true,
                    size: "medium",
                    children: tile.heading
                  }}
                  subtitle={{
                    bold: false,
                    children: tile.linkText,
                    colour: 'primary'

                  }}
                  directionalIcon={{
                    size: 'small'
                  }}
                  backgroundColor='gray'
                  tabIndex={0}
                  ViewportType={isMobile ? "mobile" : "desktop"}
                  rowQuantity={{ desktop: 2, mobile: 1 }}
                  width="555px"
                  height="200px"
                  aspectRatio="none"
                />
              ))}
            </div>
          </div>
        </SubContainer>
      </Container>
    );
  }
}

const mapStateToProps = ({
  loadingAndErrorState: { loading },
  pageContent: {
    landing_page: pageContent,
    sc_pagetitle,
    agent_landing_page_no_customers,
    breadCrumbs,
    statusText
  }
}) => ({
  loading,
  pageContent,
  sc_pagetitle,
  agent_landing_page_no_customers,
  breadCrumbs,
  statusText
});

AuthorizedAgentLanding.propTypes = {
  setA11yContent: PropTypes.func,
  loading: PropTypes.bool
};

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, agentSelectCustomer, setBreadcrumbList }
  ),
  FetchPageContent
)(AuthorizedAgentLanding);

const Container = styled.div`
  max-width: 1272px;
  margin: 0 auto;
  padding: 48px 0;

  ${media.mobile`
    margin: 25px auto;
    padding: 0;
  `};
`;

const Button = styled.button`
  background: 0;
  border: 0;
  text-decoration: underline;
  cursor: pointer;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px

  ${media.mobile`
    text-align: left;
  `}
`;


const H3 = styled.h3`
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-size: 32px;
   font-style: normal;
   font-weight: 700;
   line-height: 36px;
   marginBottom: "20px"
`;

const PaginationDiv = styled.div`
    display:flex
    justify-content:center;
    align-items: center;
    max-width: 808px;
`;

const StyledPagination = styled.nav.attrs({
  role: "navigation",
  "aria-label": "Pagination Navigation"
})`
  max-width: 808px;

  ul {
    text-align: center;
    margin-top: 24px;
    line-height: 22px;
  }

  li {
    display: inline-block;
    margin: 0 6px;
    cursor: pointer;
  }

  a {
    padding: 1px 3px;
  }

  .previousPageLink {
    margin-right: 34px;

    svg {
      transform: rotate(180deg);
      margin-right: 6px;
    }
  }

  .nextPageLink {
    margin-left: 34px;

    svg {
      margin-left: 6px;
    }
  }

  .activePage a,
  .previousPageLink,
  .nextPageLink {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }

  ${({ hidePreviousPageLink }) =>
    hidePreviousPageLink &&
    `
    .previousPageLink {
      display: none;
    }
  `}

  ${({ hideNextPageLink }) =>
    hideNextPageLink &&
    `
    .nextPageLink {
      display: none;
    }
  `}
`;

const SubContainer = styled.div`
  padding: 0 20px;

  ${media.mobile`
    padding: 0 16px;
  `};
`;

const HeaderDesc = styled.div`
  margin-bottom: 48px;
  max-width: 597px;

  p:first-of-type {
    margin-bottom: 24px;
  }

  p {
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  margin: 16px 0;
  }

  p strong {
    margin-bottom: -16px;
    display: inherit;
  }
`;

const TableContainer = styled.div`
  max-width: 808px;
  overflow-x: auto;
  overflow-y: hidden;
  font-size: 14px;
  line-height: 16px;
  width: 100%;

  ${media.mobile`
         font-size: 12px;
         line-height: 14px;
       `}
`;

const H1 = styled.h1`
  font-family:"Verizon NHG DS", Helvetica, Arial, sans-serif;
 font-size: 48px;
 font-style: normal;
 font-weight: 300;
 line-height: 48px; /* 100% */
 letter-spacing: 0.25px;
  max-width: 597px;
  margin-top: 64px;
  margin-bottom: 32px;

  ${media.mobile`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
    margin-top: 32px;
  `};
`;


const TR = styled.tr`
tr .uniqueCustId:last-child {
  border-bottom: 0px !important;
}
  border-bottom: 1px solid;

  
`;

const Tableheader = styled.th`
  text-align: left;
  padding: 19px 32px 19px 0px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  min-width: 130px;

  ${media.mobile`
    font-size: 16px;
    padding: 14px 0;
  `}
`;

const TD = styled.td`
  padding: 24px 1px;

  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  ${media.mobile`
    padding: 20px 0px;    
  `}
`;

const H2 = styled.h2`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;

  ${media.mobile`
  font-family: 'Verizon NHG eDS';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  `};
`;

const P = styled.p`
margin:24px 0px 24px 0px;
font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
`;

const Tile = styled(CommonTile)`
  flex-basis: 48%;  
  margin-right:24px;
 background-color:#F6F6F6;
  span.tile_desc{
  max-width:548px;
  font-family: 'Verizon-NHG-eTX', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  }

  span.tile_text{
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
    font-style: normal;
    font-weight: 700; 
    font-size: 20px;
    line-height: 24px;
    ${media.mobile`
    font-size: 16px;
  `}
}


  ${media.mobile`
    flex-basis: 100%;
    margin-right:0px;
    margin-bottom:12px;
  `}
`;

const ButtonDescription = styled.p`
  margin-top: 5px;
  max-width: 526px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: 0.5px;
  color:#6F7171;

  ${media.mobile`
  max-width: 296px;
  font-family: Verizon NHG eTX;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  `};
`;
